import type { AssignmentsType } from 'core/types';

export default (current: AssignmentsType) => {
  const now = new Date().toISOString();

  return current?.updated ? { updated: now } : { updated: now, created: now };
};
